import './_cart-upsells.scss';
import component from './cart-upsells';

export default component;
